/**
 * Calculates the real header height 
 */

function getElHeight(classname) {
  let el = document.querySelector(classname);
  let elH = el ? el.offsetHeight : 0;

  return elH;
}

function getHeaderHeight() {
  let els = [
    '.header__bar', 
    '.header__menu', 
    '.menu-header-nav__menu > [class*="current"] > .sub-menu', 
  ];
  let h = 0;

  for (var x = 0; x < els.length; x++) {
    h += getElHeight(els[x]);
  }

  let root = document.documentElement;
  root.style.setProperty('--headerh', h + "px");
};

function runHeaderHeightLogic() {
  // we want this to run as soon as possible
  getHeaderHeight();
  // but we also need to account for transition times between breakpoints
  setTimeout(getHeaderHeight, 150);
}

window.onresize = runHeaderHeightLogic;
getHeaderHeight();


